const formats = require('../../js-handler/math');

export function init(detail) {
    switch (detail.act) {
        case 'generator':
            return generator(detail);
        default:
            console.error(`Acción ${detail.act} no reconocida en behaivor`);
            return '';
    }
}

export function generator(data) {
    const values = (typeof data === 'string') ? JSON.parse(data) : data;

    const metrics = Object.entries(values).map(([key, value]) => ({
        label: key.replace('_star', '').toUpperCase(),
        val: parseInt(value) || 0
    }));

    const count = metrics.length;

    let html = `<span class="behaivor-main-conten pogress_for_${count}">`;

    metrics.forEach(m => {
        html += `
            <div class="behaivor behaivor_${m.val}" title="${m.label}: ${m.val}">
                <div class="behaivorElem">
                    <div class="bar">
                        <span class="bar1"></span><span class="bar2"></span>
                        <span class="bar3"></span><span class="bar4"></span>
                        <span class="bar5"></span>
                    </div>
                    <label>${m.label}</label>
                </div>
            </div>`;
    });

    html += '</span>';

    return html;
}

export function generateBar(data) {
    const starLevel = data || 0;
    
    // Retornamos solo el div del comportamiento, sin <td>
    return `
        <div class="behaivor behaivor_${starLevel}" title="Nivel ${starLevel}">
            <div class="behaivorElem">
                <div class="bar">
                    <span class="bar1"></span>
                    <span class="bar2"></span>
                    <span class="bar3"></span>
                    <span class="bar4"></span>
                    <span class="bar5"></span>
                </div>
            </div>
        </div>`;
}

export function generateTable(data, columns) {
    const values = (typeof data === 'string') ? JSON.parse(data) : data;
    const columnCount = columns.length;

    // 1. Inicio de la tabla con clase para estilos globales
    let html = '<table class="behaivor-quickview-table">';

    // 2. Encabezado Manual basado en el array 'thead' pasado
    html += '<thead><tr>';
    columns.forEach(col => {
        // Limpieza de etiquetas: 'revenue' -> 'PROFIT', 'rperishableoi' -> 'PERISHABLE'
        let label = col.replace('revenue', 'profit').replace('rperishableoi', 'perishable');
        html += `<th>${label.toUpperCase()}</th>`;
    });
    html += '</tr></thead>';

    // 3. Fila de Datos y Barras
    html += '<tbody><tr>';
    columns.forEach(col => {
        console.log(col)
        // Normalización de llaves para buscar en el JSON
        const key = (col === 'revenue') ? 'profit' : (col === 'rperishableoi' ? 'perishable' : col);
        const val = values[key] || '0';
        const starLevel = parseInt(values[`${key}_star`]) || 0;

        let displayValue;

        if (key === 'roi' || key === 'perishable') {
            displayValue = formats.percentFormat(val, 2);
        } else if (key === 'profit' || key === 'inversion') {
            displayValue = formats.cashFormat(val, true);
        } else if (key === 'friction') {
            displayValue = parseFloat(val).toFixed(2);
        } else if (key === 'speed') {
            displayValue = parseInt(val);
        } else {
            displayValue = val;
        }

        html += `
                <td>
                    <div class="cell-data">                        
                        <div class="behaivor behaivor_${starLevel}" title="Nivel ${starLevel}">
                            <div class="behaivorElem">
                                <div class="bar">
                                    <span class="bar1"></span>
                                    <span class="bar2"></span>
                                    <span class="bar3"></span>
                                    <span class="bar4"></span>
                                    <span class="bar5"></span>
                                </div>
                            </div>
                        </div>

                        <span class="value-text">${displayValue}</span>
                    </div>
                </td>`;
    });
    html += '</tr></tbody></table>';

    return html;
}